import styled from "styled-components";
import MUISwitch from "@mui/material/Switch";

import { breakpoints } from "@/styles/breakpoints";

export const StyledEnvironmentSwitchContainer = styled.div`
    width: fit-content;
    padding: 9.5px 12px 9.5px 12px;
    font-size: var(--size-14);
    background: var(--color-secondary-light);
    border-radius: var(--radius-10);
    text-transform: uppercase;
    display: flex;
    align-items: center;

    @media ${breakpoints.xs} {
        font-size: var(--size-12);
        margin-top: 0;
    }
`;

export const StyledEnvironmentSwitchLabelPrivate = styled.span<{ $active: boolean }>`
    color: ${(props) => (props.$active ? "var(--color-secondary)" : "var(--color-grey-800)")};
`;

export const StyledEnvironmentSwitchLabelPro = styled.span<{ $active: boolean }>`
    color: ${(props) => (props.$active ? "var(--color-primary)" : "var(--color-grey-800)")};
`;

export const StyledEnvironmentSwitch = styled(MUISwitch)`
    width: 24px;
    height: 16px;
    border-radius: 12.5px;
    padding: 0;
    margin: 0 15px;
    background-color: var(--color-secondary);

    @media ${breakpoints.xs} {
        margin: 0 5px;
    }

    .track {
        opacity: 0;
    }

    .switchBase {
        color: var(--color-secondary-light);
        padding: 0;
        margin: 2px;
    }

    .thumb {
        width: 12px;
        height: 12px;
    }

    .checked {
        background-color: var(--color-secondary);
        transform: translateX(8px);
    }
`;
